module.exports = __webpack_public_path__ + "static/media/brand2.8651f518.png";